<div
  class="marquee-text"
  #container
  [class.marquee-text--active]="effectiveActive() && overflow()"
  (mouseenter)="hovered.set(true)"
  (mouseleave)="hovered.set(false)">
  <span #inner class="marquee-text__inner">{{ text() }}</span>
</div>
